<script>
    import MainContainer from "./MainContainer.svelte"
    import ExperimentList from "./ExperimentList.svelte";
    
    let experimentsSize = 0
    let sortOrder = ""

	import {afterUpdate} from 'svelte'
	afterUpdate(async () => {
		const selects = document.querySelectorAll('select')
		M.FormSelect.init(selects)
	})    
</script>

<MainContainer>
    <a href="#/Experiment/-1" class="btn-floating waves-effect waves-light right">
        <i class="large material-icons">add</i>
    </a>
    <h5 class="col s5">Active experiments ({experimentsSize})
    </h5>

	<div class="input-field col s3">
		<select bind:value={sortOrder}>
			<option value="">Default</option>
			<option value="name">Name</option>
			<option value="startTime">Start time</option>
			<option value="endTime">End time</option>
		</select>
		<label>Sort order:</label>
	</div>

    <ExperimentList bind:experimentsSize bind:sortOrder/>
</MainContainer>

<style>
</style>